import {Stack, Typography} from "@mui/material";

const StackedLabel = ({label, subLabel}) => {
  if (subLabel) {
    return (
      <Stack>
        <Typography variant="subtitle1">
          {label}
        </Typography>
        <Typography variant="subtitle2" color="secondary">
          {subLabel}
        </Typography>
      </Stack>
    );
  } else {
    return (
      <Typography>
        {label}
      </Typography>
    );
  }
};

export {
  StackedLabel
};
